import { confirm, toast } from "@/controllers/alert";

export const branchRenewal = {
  data: () => ({
    renewal: { package: null, pending_branch_ids: [] },
    renewing: false,
  }),
  methods: {
    async fetchRenewal() {
      try {
        const { data } = await this.$http.get("branch_renewal");
        if (data.status && data.data) {
          this.renewal = {
            package: data.data.package || null,
            pending_branch_ids: data.data.pending_branch_ids || [],
          };
        }
      } catch (error) {
        this.renewal = { package: null, pending_branch_ids: [] };
      }
    },
    isRenewPending(branchId) {
      return this.renewal.pending_branch_ids.includes(Number(branchId));
    },
    async renewBranch(branch) {
      if (!this.renewal.package || this.renewing) return false;
      const { isConfirmed } = await confirm({
        props: this,
        text: "renew_branch_confirm",
        textParams: { name: branch.name },
      });
      if (!isConfirmed) return false;
      this.renewing = true;
      try {
        const { data } = await this.$http.post("make_order", {
          package_id: this.renewal.package.id,
          renew_branch_id: branch.id,
        });
        if (data.status) {
          await toast(this, "order_create_success");
        }
        await this.fetchRenewal();
        return true;
      } catch (error) {
        // package_order_exists etc. — the interceptor already alerted; refresh pending state
        await this.fetchRenewal();
        return false;
      } finally {
        this.renewing = false;
      }
    },
  },
};
